import { Plotly } from "vue-plotly";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import router from "@/router";

Vue.use(Loading);

export default {
  name: "side_bar",
  components: {
    Loading,
    Plotly
  },
  data: () => ({
    subjects: "",
    scales: "",
    scale: "",
    subject: "",
    layerRef: "",
    styleRef: "",
    layerData: {},
    plotData: [{ name: "none", popData: 0, color: "#440154" }],
    plotX: ["1", "2"],
    plotY: [0, 1],
    showPlot: false,
    showFacilities: false,
    plotType: "",
    xLabel: "",
    yLabel: "",
    plotTitle: "",
    legendTitle: "",
    stacked: "",
    plotlyMain: [],
    xShowticklabels: true,
    loadingVisible: false,
    switchVisible: false,
    switchStack: false,
    switchLabel: "Histogram",
    loader: "",
    plotInfo30: "",
    plotInfo60: "",
    plotInfo70: "",
    layerTransparency: 70
  }),
  props: ["countryCode", "countryName", "facilityType", "scaleType", "country"],
  watch: {
    facilityType() {
      this.initTypeAndScale();
    },
    scaleType() {
      this.initTypeAndScale();
    },
    subject() {
      this.updateLayer();
      this.loadData();
    },
    scale() {
      this.updateLayer();
      this.loadData();
    },
    layerTransparency() {
      let transparencyValue = this.layerTransparency;
      this.$emit("getLayerTransparency", transparencyValue);
    },
    showFacilities() {
      this.$emit("getShowFacilities", this.showFacilities);
    }
  },
  methods: {
    switchPlot() {
      if (this.switchStack) {
        this.prepADM1Plot();
        this.switchStack = false;
        this.switchLabel = "Histogram";
        this.plotInfo = "Explanatory text adm1 - stacked barchart.";
      } else {
        this.prepEntityHistogram();
        this.switchStack = true;
        this.switchLabel = "Barchart";
        this.plotInfo = "Explanatory text adm1 - histogram.";
      }
    },
    histogramColors(popVal) {
      let colorSet = [
        /* viridis
               "#440154", // 0-10
                "#472878", // 10-20
                "#3e4a89", // 20-30
                "#31688e", // 30-40
                "#1e9e89", // 40-50
                "#1e9e89", // 50-60
                "#35b779", // 60-70
                "#6cce59", // 70-80
                "#b5de2c", // 80-90
                "#fde725"  // 90-100*/
        // PuRd
        /* "#f1eef6", // 0-10
                "#e6d5e9", // 10-20
                "#dabcdc", // 20-30
                "#da9acb", // 30-40
                "#de77b9", // 40-50
                "#df55a3", // 50-60
                "#de348a", // 60-70
                "#d61871", // 70-80
                "#b70c5a", // 80-90
                "#980043" // 90-100*/
        // custom YlPu
        "#ffffda", // 0-10
        "#ffe9b8", // 10-20
        "#ffd297", // 20-30
        "#feb779", // 30-40
        "#fe9b5e", // 40-50
        "#fb7b4e", // 50-60
        "#f5564a", // 60-70
        "#eb344a", // 70-80
        "#d41a51", // 80-90
        "#bd0058" // 90-100*/
      ];
      //let returnColors = [];
      popVal = popVal.sort(function(a, b) {
        return a - b;
      });
      popVal = popVal.map(function(x) {
        return parseInt(
          parseInt(x, 10)
            .toString()
            .slice(0, -1),
          10
        );
      });
      popVal = popVal.map(x => (isNaN(x) ? 0 : x));
      popVal = popVal.map(x => (x == 10 ? 9 : x));
      popVal = [...new Set(popVal)];
      let popValmin = Math.min.apply(Math, popVal);
      let popValmax = Math.max.apply(Math, popVal);

      let returnColors = colorSet.slice(popValmin, popValmax + 1);
      return returnColors;
    },
    backToWorldView() {
      //this.$emit("sidebar", false);
      router.push("/");
      this.$emit("resetSelectedCountry");
    },
    layerChosen() {
      let urlId =
        "/countries/" +
        this.countryCode.toLowerCase() +
        "/" +
        this.subject.ref +
        "/" +
        this.scale.ref;

      router.push(urlId);
    },
    updateLayer() {
      if (this.scale.ref == "adm0") {
        this.layerRef =
          this.countryCode +
          "_" +
          this.subject.ref +
          "_" +
          this.scale.refGeoServer +
          "_layer";
        this.styleRef = "iso_value_viridis";
      } else {
        this.layerRef =
          this.countryCode + "_" + this.scale.refGeoServer + "_layer";
        this.styleRef =
          "scale_" + this.subject.ref + "_3600_10class_customYlPu";
      }
      this.$emit("getLayerName", this.layerRef);
      this.$emit("getLayerStyle", this.styleRef);
    },
    async loadData() {
      this.showPlot = false;
      this.loadingVisible = true;
      const response = await fetch(
        process.env.VUE_APP_GEOSERVER_URL +
          "service=WFS&version=1.0.0" +
          "&request=GetFeature&typeName=health-acc:" +
          this.layerRef +
          "_centroid&maxFeatures=5000&outputFormat=application/json"
      );
      const rawJson = await response.json();
      this.layerData = rawJson;
      this.decidePlotType();
    },
    decidePlotType() {
      //determine plot type
      if (this.layerRef.includes("iso")) {
        this.prepIsoPlot();
        this.switchVisible = false;
        this.plotTitle = "Coverage by travel time";
      } else if (this.layerRef.includes("adm1")) {
        //this.prepEntityHistogram();
        this.prepADM1Plot();
        this.switchVisible = true;
        this.switchStack = false;
        this.plotTitle = "Coverage within admin units";
      } else if (this.layerRef.includes("adm2") || this.layerRef.includes("adm3")) {
        this.prepEntityHistogram();
        this.switchVisible = false;
        this.plotTitle = "Coverage within admin units (2)";
        this.plotInfo = "Explanatory text adm2 - histogram.";
      } else if (this.layerRef.includes("hex")) {
        this.prepEntityHistogram();
        this.switchVisible = false;
        this.plotTitle = "Coverage within hexbins";
        this.plotInfo = "Explanatory text hex - histogram";
      } else {
        console.log("tbd.");
      }
      this.loadingVisible = false;
      this.showPlot = true;
    },
    prepIsoPlot() {
      let plotArray = [];
      let features = this.layerData.features;
      let f;
      let isoVal;
      for (f in features) {
        isoVal = features[f].properties.value / 60.0;
        isoVal = isoVal.toString();
        if (isoVal == "70") {
          isoVal = "70";
        }
        plotArray.push({
          name: isoVal,
          popData: features[f].properties.pop_r
        });
      }
      plotArray.sort(function(a, b) {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
      });
      this.plotData = {
        name: plotArray.map(a => a.name),
        popData: plotArray.map(a => a.popData),
        color: [
          "#fbe625",
          "#8ed644",
          "#35b679",
          "#208f8c",
          "#31688e",
          "#443a83",
          "#440154"
        ]
      };
      this.yLabel = "Pop share (%)";
      this.xShowticklabels = true;
      this.xLabel = "Travel time (Min.)";
      this.plotType = "bar";
      this.stacked = "";
      this.plotlyMain = [
        {
          //y: ["test0", "test1", "test2", "test3", "test4", "test5"],
          // x: [30.0, 32.0, 55.2, 78.2, 83.1,91.3],
          x: this.plotData.name,
          y: this.plotData.popData,
          marker: {
            color: this.plotData.color,
            opacity: 0.85,
            line: {
              color: "rgb(130,130,130)",
              width: 1.5
            }
          },
          type: this.plotType
        }
      ];
      this.xRange = [5, 75];
      let less30Min_rel = features[2].properties.pop_r_a;
      let less60Min_rel = features[5].properties.pop_r_a;
      let greater60Min_rel = features[6].properties.pop_r;

      let less30Min_abs = features[2].properties.pop_a;
      let less60Min_abs = features[5].properties.pop_a;
      let greater60Min_abs = features[6].properties.pop;

      this.plotInfo30 =
        this.numberWithCommas(less30Min_abs) +
        " (" +
        less30Min_rel +
        " %) people live within less than 30 minutes travel time (motorized) to the next facility.";
      this.plotInfo60 =
        this.numberWithCommas(less60Min_abs) +
        " (" +
        less60Min_rel +
        " %) live within less than 60 minutes travel time to the next facility.";
      this.plotInfo70 =
        this.numberWithCommas(greater60Min_abs) +
        " (" +
        greater60Min_rel +
        " %) live  further away than 60 minutes travel time to the next facility.";
    },
    prepEntityHistogram() {
      let plotVar = this.subject.ref + "_3600_r_a";
      let plotArray = [];
      let features = this.layerData.features;
      let f;
      let popValues = [];
      for (f in features) {
        let popValueEdit = features[f].properties[plotVar];
        if (popValueEdit >= 100.0) {
          popValueEdit = 90.0;
        }
        popValues.push(popValueEdit);
        plotArray.push({
          //name: features[f].properties[plotVar],
          //popData: features[f].properties[plotVar]
          name: popValueEdit,
          popData: popValueEdit
        });
      }
      let histColors = this.histogramColors(popValues);
      this.plotData = {
        //"name": plotArray.map(a => a.name),
        name: "",
        popData: plotArray.map(a => a.popData),
        color: histColors
      };
      this.yLabel = "Frequency";
      this.xLabel = "Pop. within 1 hr";
      this.xShowticklabels = true;
      this.plotType = "histogram";
      this.stacked = "";
      this.plotlyMain = [
        {
          //y: ["test0", "test1", "test2", "test3", "test4", "test5"],
          // x: [30.0, 32.0, 55.2, 78.2, 83.1,91.3],
          //x: this.plotData.name,
          //y: this.plotData.popData,
          y: this.plotData.name,
          x: this.plotData.popData,
          marker: {
            color: this.plotData.color,
            opacity: 0.85,
            line: {
              color: "rgb(130,130,130)",
              width: 1.5
            }
          },
          autobinx: false,
          xbins: {
            end: 100.0,
            size: 10,
            start: 0.0
          },
          type: this.plotType
        }
      ];
      this.xRange = [0, 100];

      let varLess30 = this.subject.ref + "_1800_r_a";
      let varLess60 = this.subject.ref + "_3600_r_a";
      //let varGreater60 = this.subject.ref + "_4200_r";

      let less30Min_count = features.filter(function(item) {
        return item.properties[varLess30] > 50.0;
      }).length;
      let less60Min_count50 = features.filter(function(item) {
        return item.properties[varLess60] < 50.0;
      }).length;
      let greater60Min_count50 = features.filter(function(item) {
        return item.properties[varLess60] > 50.0;
      }).length;
      let less60Min_count25 = features.filter(function(item) {
        return item.properties[varLess60] > 25.0;
      }).length;
      let greater60Min_count25 = features.filter(function(item) {
        return item.properties[varLess60] < 25.0;
      }).length;

      this.plotInfo30 =
        "Within 30 minutes travel time, " +
        less30Min_count +
        " / " +
        features.length +
        " unit(s) cover more than 50% of people.";
      this.plotInfo60 =
        "Within 60 minutes, " +
        greater60Min_count50 +
        " / " +
        features.length +
        " unit(s) cover more than 50% of people. " +
        less60Min_count50 +
        " unit(s) cover less.";
      this.plotInfo70 =
        less60Min_count25 +
        " / " +
        features.length +
        " unit(s) cover more than 25% of people. " +
        greater60Min_count25 +
        " unit(s) cover less.";
    },
    prepADM1Plot() {
      let values = ["600", "1200", "1800", "2400", "3000", "3600", "4200"];
      let valuesMin = ["10", "20", "30", "40", "50", "60", ">60"];
      let colors = [
        "#fbe625",
        "#8ed644",
        "#35b679",
        "#208f8c",
        "#31688e",
        "#443a83",
        "#440154"
      ];
      let subject = this.subject.ref;
      let plotArray = [];
      let v;
      let f;
      let features = this.layerData.features;
      let sortIdx;
      let origIdx;
      let orderedNames = [];
      let orderedVals = [];

      for (v in values) {
        let singleEntity = {
          x: [],
          y: [],
          name: valuesMin[v],
          type: "bar",
          marker: {
            color: colors[v]
          }
        };
        for (f in features) {
          singleEntity.x.push(features[f].properties.entity_name),
            singleEntity.y.push(
              features[f].properties[subject + "_" + values[v] + "_r"]
            );
        }
        if (v == 0) {
          //let val600 = [...singleEntity.y];
          let nam600 = [...singleEntity.x];

          //origIdx = singleEntity.y.map(function(x){return val600.indexOf(x)});
          origIdx = [...Array(singleEntity.y.length).keys()];

          //sorting
          //1) combine the arrays:
          var list = [];
          for (var j = 0; j < singleEntity.y.length; j++)
            list.push({ name: singleEntity.y[j], age: singleEntity.x[j] });

          //2) sort:
          list.sort(function(a, b) {
            return a.name > b.name ? -1 : a.name == b.name ? 0 : 1;
            //Sort could be modified to, for example, sort on the age
            // if the name is the same.
          });

          //3) separate them back out:
          for (var k = 0; k < list.length; k++) {
            singleEntity.y[k] = list[k].name;
            singleEntity.x[k] = list[k].age;
          }

          sortIdx = singleEntity.x.map(function(x) {
            return nam600.indexOf(x);
          });

          /*val600.sort(function(a, b) {
                      return a - b;
                    });
                    sortIdx = singleEntity.y.map(function(x) {
                      return val600.indexOf(x);
                    });

                    orderedNames = origIdx.map(function(x) {
                      return singleEntity.x[sortIdx.indexOf(x)];
                    });
                    orderedVals = origIdx.map(function(x) {
                      return singleEntity.y[sortIdx.indexOf(x)];
                    });*/
          //singleEntity.y = orderedVals;
          //singleEntity.x = orderedNames;
        } else {
          orderedNames = origIdx.map(function(x) {
            return singleEntity.x[sortIdx.indexOf(x)];
          });
          orderedVals = origIdx.map(function(x) {
            return singleEntity.y[sortIdx.indexOf(x)];
          });
          singleEntity.y = orderedVals;
          singleEntity.x = orderedNames;
        }
        plotArray.push(singleEntity);
      }

      this.plotData = plotArray;
      this.yLabel = "Pop % classes";
      this.xLabel = "Units (admin level 1)";
      this.xShowticklabels = false;
      this.xTickformat = "";
      this.plotType = "bar";
      this.stacked = "stack";
      this.plotlyMain = this.plotData;
      this.legendTitle = "Travel time in minutes";
      this.xRange = [-0.5, features + 0.5];
      let varLess30 = this.subject.ref + "_1800_r_a";
      let varLess60 = this.subject.ref + "_3600_r_a";
      //let varGreater60 = this.subject.ref + "_4200_r";

      let less30Min_count = features.filter(function(item) {
        return item.properties[varLess30] > 50.0;
      }).length;
      let less60Min_count50 = features.filter(function(item) {
        return item.properties[varLess60] < 50.0;
      }).length;
      let greater60Min_count50 = features.filter(function(item) {
        return item.properties[varLess60] > 50.0;
      }).length;
      let less60Min_count25 = features.filter(function(item) {
        return item.properties[varLess60] > 25.0;
      }).length;
      let greater60Min_count25 = features.filter(function(item) {
        return item.properties[varLess60] < 25.0;
      }).length;

      this.plotInfo30 =
        "Within 30 minutes travel time, " +
        less30Min_count +
        " / " +
        features.length +
        " unit(s) cover more than 50% of people.";
      this.plotInfo60 =
        "Within 60 minutes, " +
        greater60Min_count50 +
        " / " +
        features.length +
        " unit(s) cover more than 50% of people. " +
        less60Min_count50 +
        " unit(s) cover less.";
      this.plotInfo70 =
        less60Min_count25 +
        " / " +
        features.length +
        " unit(s) cover more than 25% of people. " +
        greater60Min_count25 +
        " unit(s) cover less.";
    },
    getSubject() {
      let subject;
      if (this.layerRef.includes("primary")) {
        subject = "primary";
      } else if (this.layerRef.includes("secondary")) {
        subject = "secondary";
      } else if (this.layerRef.includes("both")) {
        subject = "both";
      }
      return subject;
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    initTypeAndScale() {
      let chosenSubject = this.subjects.filter(
        x => x.ref === this.facilityType
      )[0];
      this.subject = chosenSubject;
      let chosenScale = this.scales.filter(x => x.ref === this.scaleType)[0];
      this.scale = chosenScale;
    }
  },
  computed: {
    plotlyData() {
      return this.plotlyMain;
    },
    layout() {
      return {
        font: {
          size: 16,
          color: "#000001"
        },
        legend: {
          xanchor: "center",
          orientation: "h",
          title: { text: this.legendTitle, side: "top" },
          x: "0.5",
          y: "-.3"
        },
        paper_bgcolor: "#ffffff",
        plot_bgcolor: "#ffffff",
        xaxis: {
          title: this.xLabel,
          showticklabels: this.xShowticklabels,
          range: this.xRange
        },
        yaxis: {
          title: this.yLabel,
          tickangle: 0,
          gridcolor: "#797878"
        },
        barmode: this.stacked,
        margin: {
          l: 50,
          r: 50,
          b: 50,
          t: 2,
          pad: 4
        }
      };
    }
  },
  mounted: function() {
    //this.loadData(); deprecated
  },
  created() {
    let standardSubjects = [
      { key: 1, name: "Primary care", ref: "primary" },
      { key: 2, name: "Secondary and tertiary care", ref: "secondary" },
      { key: 3, name: "Both types", ref: "both" }
    ];

    let standardScales = [
      { key: 1, name: "National", ref: "adm0", refGeoServer: "iso" }
    ];

    /*if (this.country.properties.adm0) {
      standardScales.push({
        key: 1,
        name: "National",
        ref: "adm1",
        refGeoServer: "iso"
      });
    }*/

    if (this.country.properties.adm1) {
      standardScales.push({
        key: 2,
        name: "Administrative level 1 [agg.]",
        ref: "adm1",
        refGeoServer: "adm1"
      });
    }

    if (this.country.properties.adm2) {
      standardScales.push({
        key: 3,
        name: "Administrative level 2 [agg.]",
        ref: "adm2",
        refGeoServer: "adm2"
      });
    }

    if (this.country.properties.adm3) {
      standardScales.push({
        key: 4,
        name: "Administrative level 3 [agg.]",
        ref: "adm3",
        refGeoServer: "adm3"
      });
    }

    if (this.country.properties.hex8) {
      standardScales.push({
        key: 5,
        name: "Hexagon (ISEA3H level 8) [agg.]",
        ref: "hex",
        refGeoServer: "hex_z8"
      });
    }

    if (this.country.properties.covid19_vaccination) {
      standardSubjects.push({
        key: 6,
        name: "COVID-19 Vaccination sites",
        ref: "covid19_vaccination",
        refGeoserver: "vaccination_iso_layer"
      });
    }

    if (this.country.properties.maternal_health) {
      standardSubjects.push({
        key: 7,
        name: "Birthing Center Sites",
        ref: "maternal_health",
        refGeoserver: "maternal_health_iso_layer"
      });
    }

    if (this.country.properties.education) {
      standardSubjects.push({
        key: 8,
        name: "Schools",
        ref: "education",
        refGeoserver: "education_iso_layer"
      });
    }


    this.subjects = standardSubjects;
    this.scales = standardScales.sort(function(a, b) {
      if (a.key < b.key) {
        return -1;
      }
      if (a.key > b.key) {
        return 1;
      }
      return 0;
    });

    this.initTypeAndScale();
  }
};
